import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import PersonData from "./PersonData";
import PersonEvolution from "./PersonEvolution";
import PersonStrenghts from "./PersonStrengths";

function PersonOverviewDashboard({
  generalData,
  strenghts,
  weaknesses,
  talentAssessments,
  performanceAssessments,
  language,
}) {
  return (
    <Container>
      <Row>
        <Col lg={4}>
          <Col>
            <PersonData
              id={generalData.id}
              categories={generalData.categories}
              firstName={generalData.firstName}
              lastName={generalData.lastName}
              directBoss={generalData.boss}
              profile={generalData.profile}
              profileEnglish={generalData.profileEnglish}
              profilePicture={generalData.profilePictureURL}
              language={language}
            />
          </Col>
          <Col>
            <PersonStrenghts
              weaknesses={weaknesses}
              strenghts={strenghts}
              language={language}
            />
          </Col>
        </Col>
        <Col lg={8}>
          <Col className="mb-3">
            <PersonEvolution datasource={talentAssessments} />
          </Col>
          <Col>
            <PersonEvolution datasource={performanceAssessments} />
          </Col>
        </Col>
      </Row>
    </Container>
  );
}

export default PersonOverviewDashboard;
